import "./regionPage.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import newRequest from "../../context/newRequest";
import useRegions from "../../hooks/useRegions";

const RegionPage = () => {
  const { regions, loading, refreshRegions } = useRegions();
  const [regionId, setRegionId] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [searchQuery, setSearchQuery] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!regionId.trim()) {
      setMessage({ type: "error", text: "Region ID / Name tidak boleh kosong!" });
      return;
    }

    setSubmitting(true);
    setMessage({ type: "", text: "" });

    try {
      const res = await newRequest.post("/regions", {
        id: regionId.trim(),
        description: description.trim(),
      });

      if (res.status === 200 || res.status === 201) {
        setMessage({ type: "success", text: `Region "${regionId}" berhasil ditambahkan!` });
        setRegionId("");
        setDescription("");
        await refreshRegions();
      }
    } catch (err) {
      const errMsg =
        (err.response && err.response.data && err.response.data.errors) ||
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Gagal menambahkan region";
      setMessage({ type: "error", text: errMsg });
    } finally {
      setSubmitting(false);
    }
  };

  const filteredRegions = regions.filter((reg) => {
    const q = searchQuery.toLowerCase();
    return (
      (reg.id && reg.id.toLowerCase().includes(q)) ||
      (reg.description && reg.description.toLowerCase().includes(q))
    );
  });

  return (
    <div className="regionPage">
      <Sidebar />
      <div className="regionContainer">
        <Navbar />

        <div className="topSection">
          <h1>Manajemen Wilayah (Regions)</h1>
          <p className="subtitle">
            Buat dan kelola wilayah operasional. Setiap region yang ditambahkan akan otomatis muncul di seluruh dropdown pilihan region.
          </p>
        </div>

        <div className="contentGrid">
          <div className="card formCard">
            <h2>Tambah Region Baru</h2>
            <form onSubmit={handleSubmit}>
              <div className="inputGroup">
                <label htmlFor="regId">Region ID / Nama *</label>
                <input
                  id="regId"
                  type="text"
                  placeholder="Contoh: Kalimantan Timur"
                  value={regionId}
                  onChange={(e) => setRegionId(e.target.value)}
                  required
                />
              </div>

              <div className="inputGroup">
                <label htmlFor="regDesc">Deskripsi Region</label>
                <textarea
                  id="regDesc"
                  rows="3"
                  placeholder="Keterangan singkat mengenai cakupan wilayah..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              <button type="submit" disabled={submitting} className="submitBtn">
                {submitting ? "Menyimpan..." : "Simpan Region"}
              </button>

              {message.text && (
                <div className={`statusMsg ${message.type}`}>
                  {message.text}
                </div>
              )}
            </form>
          </div>

          <div className="card tableCard">
            <div className="tableHeader">
              <h2>Daftar Region ({regions.length})</h2>
              <input
                type="text"
                placeholder="Cari region..."
                className="tableSearch"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="tableWrapper">
              {loading && <p className="loadingText">Memuat data region...</p>}
              <table className="regionTable">
                <thead>
                  <tr>
                    <th style={{ width: "40px" }}>No</th>
                    <th>Region ID / Nama</th>
                    <th>Deskripsi</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRegions.length === 0 ? (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                        Tidak ada region yang sesuai pencarian
                      </td>
                    </tr>
                  ) : (
                    filteredRegions.map((reg, idx) => (
                      <tr key={reg.id || idx}>
                        <td>{idx + 1}</td>
                        <td className="regionIdCell">
                          <strong>{reg.id}</strong>
                        </td>
                        <td className="descCell">{reg.description || "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegionPage;
